import React, { useState } from 'react';
import { employeeApi } from '../../../../api/employeeApi';

/**
 * CategoryModal Component - Manages employee roles (categories).
 */
export function CategoryModal({ categories, onClose, onUpdate }) {
    const [newName, setNewName] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editName, setEditName] = useState('');

    const handleCreate = async () => {
        if (!newName.trim()) return;
        try {
            await employeeApi.createCategory({ name: newName });
            setNewName('');
            onUpdate();
        } catch (err) { alert('Fehler beim Erstellen'); }
    };

    const handleSave = async (id) => {
        if (!editName.trim()) { setEditingId(null); return; }
        try {
            await employeeApi.updateCategory(id, { name: editName });
            setEditingId(null);
            onUpdate();
        } catch (err) { alert('Fehler'); }
    };

    const handleDelete = async (id) => {
        try {
            await employeeApi.deleteCategory(id);
            onUpdate();
        } catch (err) {
            if (err.response?.status === 409) {
                if (window.confirm(err.response.data.message || 'Diese Rolle wird noch verwendet. Trotzdem löschen?')) {
                    try {
                        await employeeApi.deleteCategory(id, true);
                        onUpdate();
                    } catch { alert('Fehler'); }
                }
            } else {
                alert('Fehler beim Löschen');
            }
        }
    };

    return (
        <div className="employee-roles-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="employee-roles-modal" onClick={e => e.stopPropagation()}>
                <div className="employee-roles-header">
                    <h2>Rollen verwalten</h2>
                    <button className="employee-modal-close-btn" onClick={onClose}>✕</button>
                </div>
                
                <div className="employee-role-add-section">
                    <input
                        className="employee-role-add-input"
                        placeholder="Neue Rolle (z.B. Elektriker)"
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleCreate()}
                        autoFocus
                    />
                    <button className="employee-role-add-btn" onClick={handleCreate}>Hinzufügen</button>
                </div>

                <div className="employee-role-list">
                    {categories.length === 0 && (
                        <div style={{ padding: '40px 20px', textAlign: 'center', color: '#86868b', fontSize: '13px' }}>
                            Noch keine Rollen definiert.
                        </div>
                    )}
                    {categories.map(c => (
                        <div key={c.id} className="employee-role-item">
                            {editingId === c.id ? (
                                <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                    <input
                                        className="employee-role-add-input"
                                        value={editName}
                                        onChange={e => setEditName(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && handleSave(c.id)}
                                        onBlur={() => handleSave(c.id)}
                                        autoFocus
                                    />
                                    <button className="employee-role-icon-btn" style={{ background: '#e8f5e9', color: '#2e7d32' }} onClick={() => handleSave(c.id)}>✓</button>
                                </div>
                            ) : (
                                <>
                                    <span className="employee-role-item-name">{c.name}</span>
                                    <div className="employee-role-item-actions">
                                        <button className="employee-role-icon-btn" onClick={() => { setEditingId(c.id); setEditName(c.name); }}>✏️</button>
                                        <button className="employee-role-icon-btn delete" onClick={() => handleDelete(c.id)}>🗑️</button>
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
